"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IncidentParticipantTypeEnum;
(function (IncidentParticipantTypeEnum) {
    IncidentParticipantTypeEnum["AGGRESSOR"] = "Aggressor";
    IncidentParticipantTypeEnum["WITNESS"] = "Witness";
    IncidentParticipantTypeEnum["VICTIM"] = "Victim";
})(IncidentParticipantTypeEnum || (IncidentParticipantTypeEnum = {}));
